<template>
    <div id='impressum'>
       <body style="background-color: #292929">
            <header>
                <NavigationBar/>
            </header>
           
            <mainImpressum style="background-color: #FAFAFA;">
                <div class="row container" style="max-width: 800px;">
                    <div class="col s12" style="background-color: #FAFAFA">
                        <p style="font-size: 19px; color: #313131" class="center">
                            IMPRESSUM
                        </p>
                        <p style="font-size: 12px; color: #313131">
                            SmartX Elements GmbH<br/>
                            Brunnenkoppel 28<br/>
                            22041 Hamburg<br/>
                            <br/>
                            <span style="font-weight: bold">Telefon:</span> +49 170 4123 908<br/> 
                            <span style="font-weight: bold">E-Mail:</span> matthias (AT) smartxelements.com<br/> 
                            <span style="font-weight: bold">Internet:</span> www.smartxelements.com<br/> 
                            <br/>
                            <span style="font-weight: bold">Vertretungsberechtigter Geschäftsführer:</span> Matthias Kluender<br/>
                            <span style="font-weight: bold">Registergericht:</span> Amtsgericht Hamburg<br/> 
                            <span style="font-weight: bold">Registernummer:</span> HRB 161774 <br/>   
                            <span style="font-weight: bold">Steuer Nr.</span> 44/780/05224 <br/> 
                            <br/>
                            <span style="font-weight: bold">Inhaltlich Verantwortlicher gemäß §55 Abs. 2 RStV:</span> Matthias Kluender(Anschrift wie oben)<br/>   
                            <br/>
                            <span style="font-weight: bold">Haftungshinweis:</span> Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.<br/>             
                            <br/>
                            <span style="font-weight: bold">Gerichtsstand:</span> Für sämtliche gegenwärtigen und zukünftigen Ansprüchen aus der Geschäftsverbindung mit Kaufleuten einschließlich Scheck- und Wechselforderungen ist ausschließlich der Gerichtsstand 22041 Hamburg.<br/>
                        </p>
                    </div>
                </div>
            </mainImpressum>
           
            <footer style="background-color: #292929; position:fixed; bottom:0; width: 100%;">
                <WebsiteFooter/>
            </footer>
        </body>
    </div>
</template>

<script>
import NavigationBar from '../components/NavigationBar'

import WebsiteFooter from '../components/WebsiteFooter'

export default {
    name: 'impressum',
    data(){
        return {}
    },

    components: {
        NavigationBar,
        
        WebsiteFooter
    }
}
</script>